<div class="card" (click)="onProfileAdd.emit(true)">
  <!--  <core-avatar [avatarSrc]="null" [size]="'lg'" />-->
  <div class="add-avatar"><span class="mci-add"></span></div>
  <h3 i18n>Profiel toevoegen</h3>
</div>
